module.exports = __webpack_public_path__ + "components/page-header/static/icon-resort-c61cf2458771da4c3a7d4fe3ad7a7b4e.svg";